import * as userRequest from "@/utils/userRequest";

export default async function getSubPaymentFeeService(
    onSuccess?: (data?: any) => any,
    handleError?: (err?: any) => any
) {
    try {
        const res = await userRequest.get("sub-payment-gw/fee/info", {
            params: {
                paymentMethod: "visa",
                paymentGateway: "aipay",
            },
        });
        console.log("🚀 ~ getSubPaymentFeeService res:", res);
        if (res) {
            onSuccess && onSuccess(res);
            return res;
        }
    } catch (err) {
        console.error("🚀 ~ getSubPaymentFeeService ~ err:", err);
        handleError && handleError(err);
        throw err;
    }
}
